export default {
  units: [],
  unitsGroups: [],
  selectedUnits: [],
  unavailableUnitsIds: [],
  unitSelected: null,
  tagList: [],
  deletedTag: {},
  updatedTag: {},
}
